class CartIconBubble extends HTMLElement {
  #toggleButton = this.querySelector('[aria-controls="cart-drawer"]');
  #cartDrawer = document.querySelector('cart-drawer');

  connectedCallback() {
    if (!this.#toggleButton) return;

    this.#toggleButton.addEventListener('click', (event) => this.toggle(event));
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.#cartDrawer) return;

    this.#cartDrawer.drawer.classList.contains(this.#cartDrawer.activeClass)
      ? this.#cartDrawer.close()
      : this.#cartDrawer.open();
  }
}
customElements.define('cart-icon-bubble', CartIconBubble);
